/**
 * WalkAndPunch API
 * This is the WalkAndPunch Service API.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MasterDto } from './masterDto';
import { TemplateProjectDto } from './templateProjectDto';

export interface UserViewDtoOut { 
    id?: string;
    email?: string;
    name?: string;
    phone?: string;
    company?: string;
    disciplines?: Array<MasterDto>;
    role?: string;
    projectsTemplates?: Array<TemplateProjectDto>;
    units?: Array<MasterDto>;
    isOrganizer?: boolean;
}